export default __webpack_public_path__ + "static/media/marketplace.04baa576.svg";